<app-todo
    *ngIf="move"
    [label]="'DETAIL.METER_READINGS_MOVING_ADDRESS_SENT_TO_SUPPLIERS_BY_ADMIN' | i18nKeyTranslate: i18nKeys.RealEstateAgentDashboard"
    [state]="move.track.transferee.energyTransferMeterReadingsSentByAdmin"
>
    <app-todo-template *todoStateChecked>
        <span>{{ move.track.lastModifiedOn.energyTransferMeterReadingsSentByAdmin | formatDate }}</span>
    </app-todo-template>
</app-todo>
